<div class="widget-card forecast-widget" [ngClass]="widthClass">
  <div class="widget-header">
    <div class="chart-title">
      <span class="title-text">{{ title }}</span>
      <svg-icon 
        *ngIf="tooltipText"
        src="assets/icons/circle-question.svg" 
        class="title-icon" 
        [title]="tooltipText"
        [attr.aria-label]="title + ' Information'">
      </svg-icon>
    </div>
    <gains-ellipsis-menu 
      *ngIf="menuItems.length > 0" 
      class="ellipsis-button" 
      [menuItems]="menuItems" 
      (changeEvent)="handleMenuAction($event)">
    </gains-ellipsis-menu>
  </div>
  <highcharts-chart 
    [options]="chartOptions" 
    class="chart" 
    (chartInstance)="chartCallback($event)"
    [attr.aria-label]="title + ' chart showing ' + actualSeriesName + ' vs ' + forecastSeriesName + ' values over 12 months'">
  </highcharts-chart>
</div>